import { render, staticRenderFns } from "./ClientAssignments.vue?vue&type=template&id=24571f38&scoped=true&"
import script from "./ClientAssignments.vue?vue&type=script&lang=js&"
export * from "./ClientAssignments.vue?vue&type=script&lang=js&"
import style0 from "./ClientAssignments.vue?vue&type=style&index=0&id=24571f38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24571f38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VDivider,VList,VListItem,VListItemContent,VListItemGroup,VProgressCircular})
